import { render, staticRenderFns } from "./networkroomdetail.vue?vue&type=template&id=10bfaf98&scoped=true&"
import script from "./networkroomdetail.vue?vue&type=script&lang=js&"
export * from "./networkroomdetail.vue?vue&type=script&lang=js&"
import style0 from "./networkroomdetail.vue?vue&type=style&index=0&id=10bfaf98&scoped=scoped&lang=scss&"
import style1 from "./networkroomdetail.vue?vue&type=style&index=1&id=10bfaf98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bfaf98",
  null
  
)

export default component.exports